module.exports = __webpack_public_path__ + "media/images/sports_coaching/anton@2x-88b186fe02dea068e0617885d3c6a622.jpg";